import { render } from "./PopupComponent.vue?vue&type=template&id=703b2c24&scoped=true"
import script from "./PopupComponent.vue?vue&type=script&lang=js"
export * from "./PopupComponent.vue?vue&type=script&lang=js"

import "./PopupComponent.vue?vue&type=style&index=0&id=703b2c24&scoped=true&lang=css"

import exportComponent from "C:\\Users\\96keh\\Desktop\\dev\\liof\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-703b2c24"]])

export default __exports__